import type { SVGProps } from "react";
export interface DogIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function DogIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: DogIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M9.994 9.497c.26-.52.87-.751 1.403-.55l.105.046 6 3 .102.057a1.126 1.126 0 0 1-1.001 2.003l-.105-.047-6-3-.101-.056a1.126 1.126 0 0 1-.403-1.453M.875 8.499a1.125 1.125 0 0 1 2.25 0c0 .713.399 1.336.987 1.653l.263.117.106.044a1.125 1.125 0 0 1-.745 2.11l-.111-.033-.295-.117A4.13 4.13 0 0 1 .875 8.499m15.627-3.124.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006h-.004a1.125 1.125 0 1 1 0-2.25z"
      />
      <path
        fill={color}
        d="M20.875 6.624H19.5c-.354 0-.687-.166-.9-.45l-.9-1.199a.88.88 0 0 0-.7-.35h-3.5q-.099-.001-.193-.02l-.69 5.535c-.07.563-.55.984-1.117.984H8A3.876 3.876 0 0 0 4.125 15v5.5c0 .206.168.374.375.374h1a.375.375 0 0 0 .375-.375v-2A3.124 3.124 0 0 1 9 15.376h2a3.125 3.125 0 0 1 3.126 3.125v2c0 .206.167.374.375.374h.998a.375.375 0 0 0 .375-.375v-7.688A3.126 3.126 0 0 1 18.69 9.7l.497-.05.178-.027a1.876 1.876 0 0 0 1.511-1.84v-1.16Zm2.25 1.16a4.126 4.126 0 0 1-3.325 4.048l-.39.057-.497.05a.876.876 0 0 0-.788.871v7.69a2.625 2.625 0 0 1-2.626 2.624h-.998a2.625 2.625 0 0 1-2.625-2.625v-2a.875.875 0 0 0-.877-.874H9a.874.874 0 0 0-.875.875v2A2.625 2.625 0 0 1 5.5 23.123h-1A2.625 2.625 0 0 1 1.875 20.5V15A6.126 6.126 0 0 1 8 8.874h2.507l.876-7.013.036-.172a1.125 1.125 0 0 1 2.016-.313l.667.999H17c.983 0 1.91.463 2.5 1.25l.561.75H21.5c.897 0 1.625.728 1.625 1.625v1.785Z"
      />
    </svg>
  );
}
